import React, { useCallback, useState, useEffect } from 'react';
import { Col, Container } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from '../components/global/header';
import Footer from '../components/global/footer/index';
import PersonalCodeModal from './common/PersonalCodeModal';
import PersonalCodeCard from './common/PersonalCodeCard';
import HeadRow from './common/HeadRow';
import BotPanel from '../botPage/panel';

import { routes } from './routes';
import { logout, syncBot } from '../../actions';
import { fetchPatients, getPatientInfo } from '../../actions/patientsActions';
import { useOfficeApi } from './api';

import * as api from '../../api';
import { isMobile } from '../../utils/mobile';

const Office = ({ fetchPatients, getPatientInfo, patients, patient, user, syncBot, logout }) => {
  const { currentPatient, setPatient, personalCodeModalIsVisible, setPersonalCodeModalIsVisible } = useOfficeApi({
    patient,
    patients,
    fetchPatients,
    getPatientInfo,
    logout,
  });

  const [isMobileView, setIsMobileView] = useState(isMobile());
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  const handleClick = (e) => {
    const href = e.currentTarget.getAttribute('href');
    if (!patient.data || (patient.data.id === 0 && href !== '/office/appointments' && href !== '/office/info')) e.preventDefault();
  };

  const breadCrumbs = {
    className: 'hospital-page',
    name: 'На головну',
    url: '/',
  };
  const history = useHistory();

  const onLogout = useCallback(() => {
      history.push('/');
      logout();
    }, [history, logout]);
  
  
  return (
    <div>
      <Header breadCrumbs={breadCrumbs} />

      <main>
        <div className="user-cabinet-navigation user-cabinet-navigation--home">

          <HeadRow
            patient={currentPatient}
            patients={patients}
            setPatient={setPatient}
            user={user}
            headerLabel="Медичний кабінет пацієнта"
          />

          {!user.declarationSigned && (
            <Container>
              <div className="user-cabinet-error-message">
                <div className="user-cabinet-error-message-icon">
                  <i className="fas fa-info-circle" />
                </div>
                <div className="user-cabinet-error-message-description">
                  Нажаль, Ваша декларація укладена з сімейним лікарем, який не користується нашою системою або Ви не маєте активної декларації.
                </div>
              </div>
            </Container>
          )}

          <Container className="user-cabinet-wrapper">
            
            <PersonalCodeCard patient={currentPatient} setPersonalCodeModalIsVisible={setPersonalCodeModalIsVisible} />

            {routes.reduce((acc, { path, linkLabel, icon, isMenuItem, onlyWithDeclaration, onlyWithDiag }) => {
              const menuItem = (
                <Col md={4} key={path}>
                  <NavLink
                    className={`user-cabinet-navigation__item ${!currentPatient || (currentPatient.id === 0 && path !== '/appointments' && path !== '/info') ? 'disabled' : ''}`}
                    onClick={handleClick}
                    to={`/office${path}`}
                  >
                    <div className="user-cabinet-navigation__item-description">
                      <div className="user-cabinet-navigation__item-description-icon">
                        <img src={icon} alt={linkLabel} />
                      </div>
                      {linkLabel}
                    </div>
                    <div className="user-cabinet-navigation__item-status" />
                  </NavLink>
                </Col>
              );
              if(path === '/service-requests' && patient.data && (patient.data?.ehealth_person_uid === null || patient.data?.ehealth_person_uid === undefined)) {
                return [...acc];
              }
              if(onlyWithDiag && (!patient.data || !Array.isArray(patient.data?.diag) || patient.data.diag.length === 0)) {
                return [...acc];
              }
              return isMenuItem && (onlyWithDeclaration === undefined || onlyWithDeclaration === false || user.declarationSigned === true) ? [...acc, menuItem] : [...acc];
            }, [])}
            
            {isMobileView && user.token && (
              <>
                <div onClick={onLogout} className="col-md-4 logout">
                  <a className="user-cabinet-navigation__item " href="#">
                    <div className="user-cabinet-navigation__item-description">
                      <div className="user-cabinet-navigation__item-description-icon">
                        <i className="fas fa-sign-out-alt" />
                      </div>
                      Вихід
                    </div>
                    <div className="user-cabinet-navigation__item-status" />
                  </a>
                </div>
              </>
            )}

            <BotPanel syncBot={syncBot} showBotPanel={user.showBotPanel} />
          </Container>
        </div>
      </main>

      <Footer />

      <PersonalCodeModal
        isVisible={personalCodeModalIsVisible}
        handleClose={() => setPersonalCodeModalIsVisible(false)}
      />
    </div>
  );
};

const mapStateToProps = ({ user, patients, patient }) => ({ user, patients, patient });

const mapDispatchToProps = { logout, fetchPatients, getPatientInfo, syncBot };

export default connect(mapStateToProps, mapDispatchToProps)(Office);
